import React from 'react';

import PropTypes from 'prop-types';
import { Box, StackView, Typography } from '@telus-uds/components-web';

import {
  Thead,
  Td,
  Tr,
  Th
} from '../orderDetailsSection/ratePlans/components/css';
import getFormattedPricing from '../orderDetailsSection/utils';

const SummaryTechnicalServices = ({ technicalServices, total }) => {
  // Filter out zero-qty entries at render time. Raw map is still
  // persisted to BE (partial-merge save needs explicit qty:0 to clear
  // previously-saved entries); the in-app summary should only show
  // services the customer actually selected.
  const visibleServices = Object.keys(technicalServices).filter(
    item => technicalServices[item] && Number(technicalServices[item].quantity) > 0
  );
  if (visibleServices.length === 0) return null;
  return (
    <>
      {Object.keys(technicalServices).length > 0 && (
        <StackView space={3}>
          <Typography heading="h4" variant={{ size: 'h4' }} block>Technical Services</Typography>
          <table>
            <Thead>
              <Tr>
                <Th>Technical Services</Th>
                <Th>Unit</Th>
                <Th>Unit Price</Th>
                <Th>Total</Th>
              </Tr>
            </Thead>
            <tbody>
              {visibleServices.map(serviceName => {
                const { quantity, servicePrice } = technicalServices[
                  serviceName
                ];
                return (
                  <tr>
                    <Td style={{ background: '#f7f7f7', fontWeight: '700' }}>
                      {serviceName}
                    </Td>
                    <Td>{quantity}</Td>
                    <Td>{getFormattedPricing(servicePrice)}</Td>
                    <Td>{getFormattedPricing(servicePrice * quantity)}</Td>
                  </tr>
                );
              })}
              <Tr style={{ background: '#f4f4f4' }}>
                <Td colSpan={3}>
                  <Typography variant={{ bold: true }}>Total</Typography>
                </Td>
                <Td>
                  <Typography variant={{ bold: true }}>{getFormattedPricing(total)}</Typography>
                </Td>
              </Tr>
            </tbody>
          </table>
        </StackView>
      )}
    </>
  );
};

SummaryTechnicalServices.propTypes = {
  technicalServices: PropTypes.objectOf(PropTypes.any).isRequired,
  total: PropTypes.number.isRequired
};

export default SummaryTechnicalServices;
